import React from 'react';
import { RiskPlan } from "./riskPlan";

export function InputTemplate({
  template,
  conf
}) {
  switch (template) {
    case 'riskPlan':
      return <RiskPlan conf={conf} />;
    default:
      return null;
  }
}